import { defineSlotRecipe } from "@chakra-ui/react";

export const progressRecipe = defineSlotRecipe({
  slots: ["range"],
  className: "chakra-progress",

  variants: {
    striped: {
      true: {
        range: {
          backgroundImage: `linear-gradient(45deg, var(--tlf-colors-white-alpha-400) 25%, transparent 25%, transparent 50%, var(--tlf-colors-white-alpha-400) 50%, var(--tlf-colors-white-alpha-400) 75%, transparent 75%, transparent)`,
          backgroundSize: `var(--stripe-size) var(--stripe-size)`,
          "--stripe-size": "1rem",
        },
      },
    },
  },
});
